import Rails from "@rails/ujs";
import AwsS3 from "@uppy/aws-s3";
import Uppy from "@uppy/core";
import Dashboard from "@uppy/dashboard";

import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.min.css';


export function setupTlcForms() {
    const tlcCoverDashboard = document.getElementById('tlc_cover_uppy_dashboard');
    if (tlcCoverDashboard) {
        setupCoverDashboard(tlcCoverDashboard);
    }

    const tlcAssetsDashboard = document.getElementById('tlc_assets_uppy_dashboard');
    if (tlcAssetsDashboard) {
        setupAssetsDashboard(tlcAssetsDashboard);
    }
}

async function getAudioFileDuration(file) {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const audioBuffer = await file.arrayBuffer();
    const audioData = await audioContext.decodeAudioData(audioBuffer);
    return Math.floor(audioData.duration);
}

function setupAssetsDashboard(dashboardElement) {
    const form = dashboardElement.closest('form');

    // get data-presigned-url from form
    const presignerUrl = form.dataset.presignerUrl;

    const restrictions = {
        minNumberOfFiles: 1,
        allowedFileTypes: ['audio/mpeg']
    }

    const uppyOptions = {
        restrictions: restrictions
    };

    const dashboardOptions = {
        inline: true,
        target: dashboardElement,
        logger: Uppy.debugLogger
    }

    const s3Options = {
        getUploadParameters(file) {
            return fetch(presignerUrl, {
                method: 'post',
                // Send and receive JSON.
                headers: {
                    "accept": "application/json",
                    "content-type": "application/json",
                    "X-CSRF-Token": Rails.csrfToken()
                },
                body: JSON.stringify({
                    filename: file.name, // Always use the same filename for covers
                    contentType: file.type,
                }),
            })
                .then((response) => {
                    // Parse the JSON response.
                    return response.json();
                })
                .then((data) => {
                    // Return an object in the correct shape.
                    return {
                        method: data.method,
                        url: data.url,
                        fields: data.fields,
                    };
                });
        },
    }

    const dashboard = setupUppyDashboard(uppyOptions, dashboardOptions, s3Options);

    const sanitizeFilename = function(filename) {
        // replace spaces with underscores
        filename = filename.replace(/\s/g, '_');
        return filename;
    }

    dashboard.on('complete', async(result) => {
        const assets_data = [];

        for (const file of result.successful) {
            const filename = sanitizeFilename(file.name);
            const duration = await getAudioFileDuration(file.data);
            const asset = {
                filename: filename,
                content_type: file.type,
                duration: duration
            }
            assets_data.push(asset);
        }

        for (const file of result.failed) {
            const filename = sanitizeFilename(file.name);
            const duration = await getAudioFileDuration(file.data);

            const asset = {
                filename: filename,
                content_type: file.type,
                duration: duration
            }
            assets_data.push(asset);
        }

        const hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', 'tlc_assets_json');
        hiddenField.setAttribute('value', JSON.stringify(assets_data));
        form.appendChild(hiddenField);

        form.submit();
    });
}

function setupCoverDashboard(dashboardElement) {
    let form = dashboardElement.closest('form');
    const presignerUrl = form.dataset.presignerUrl;
    const restrictions = {
        maxNumberOfFiles: 1,
        minNumberOfFiles: 1,
        allowedFileTypes: ['image/jpeg']
    }

    const uppyOptions = {
        restrictions: restrictions
    };

    const dashboardOptions = {
        inline: true,
        target: dashboardElement,
        logger: Uppy.debugLogger
    }

    const s3Options = {
        getUploadParameters(file) {
            return fetch(presignerUrl, {
                method: 'post',
                // Send and receive JSON.
                headers: {
                    "accept": "application/json",
                    "content-type": "application/json",
                    "X-CSRF-Token": Rails.csrfToken()
                },
                body: JSON.stringify({
                    filename: "cover.jpg", // Always use the same filename for covers
                    contentType: file.type,
                }),
            })
            .then((response) => {
                // Parse the JSON response.
                return response.json();
            })
            .then((data) => {
                // Return an object in the correct shape.
                return {
                    method: data.method,
                    url: data.url,
                    fields: data.fields,
                };
            });
        },
    }

    const dashboard = setupUppyDashboard(uppyOptions, dashboardOptions, s3Options);
    dashboard.on('complete', (result) => {
        if (result.successful.length === 0) return;
        form.submit();
    });
}

function setupUppyDashboard(options, dashboardOptions, s3Options) {
    return new Uppy(options)
        .use(Dashboard, dashboardOptions)
        .use(AwsS3, s3Options);
}
